var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 5.5L19 12.6C19 14.8402 19 15.9603 18.564 16.816C18.1805 17.5686 17.5686 18.1805 16.816 18.564C15.9603 19 14.8402 19 12.6 19L5.5 19M1 4.2L1 12.3C1 13.4201 1 13.9802 1.21799 14.408C1.40973 14.7843 1.71569 15.0903 2.09202 15.282C2.51984 15.5 3.07989 15.5 4.2 15.5L12.3 15.5C13.4201 15.5 13.9802 15.5 14.408 15.282C14.7843 15.0903 15.0903 14.7843 15.282 14.408C15.5 13.9802 15.5 13.4201 15.5 12.3L15.5 4.2C15.5 3.0799 15.5 2.51984 15.282 2.09202C15.0903 1.71569 14.7843 1.40973 14.408 1.21799C13.9802 1 13.4201 1 12.3 1L4.2 1C3.07989 1 2.51984 1 2.09202 1.21799C1.71569 1.40973 1.40973 1.7157 1.21799 2.09202C1 2.51984 1 3.0799 1 4.2Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGallery);
export default __webpack_public_path__ + "static/media/IconGallery.10e41ebf4e5664ad3d2bb19a5c734fa3.svg";
export { ForwardRef as ReactComponent };